<div
    class="vertical-center height-100 width-100 template-radius"
    [ngStyle]="{
        'background-color': config.backgroundColor && config.backgroundColor !== 'null' ? config.backgroundColor : 'transparent'
    }"
>
    @if (config.image) {
        <img
            class="height-100 width-100 template-radius"
            [src]="config.image | applyPureFunction: getImageBase64"
            [ngStyle]="{
                'object-fit': config.displayType || 'none'
            }"
        />
    }
</div>
